import React, { PropsWithChildren } from 'react';

const PageContainer: React.FC<PropsWithChildren & { margin?: string }> = ({
  children,
  margin = '0.1rem',
}) => <div style={{ margin }}>{children}</div>;

export default PageContainer;
